<template>
    <div class="pay-in__body px-4 py-4">
        <label class="mb-3">Select payment scope</label>

        <div class="d-flex">
            <div
                class="pay-in__scope-card mr-3"
                :class="{
                    'pay-in__scope-card--selected': isSelected(PAYMENT_SCOPE.FULL_BOOKING)
                }"
                @click="$emit('input', PAYMENT_SCOPE.FULL_BOOKING)"
            >
                <i class="fas fa-credit-card mb-2 fs-large" :class="isSelected(PAYMENT_SCOPE.FULL_BOOKING) ? 'pay-in__selected-color' : 'dark'"></i>
                <strong class="font-weight-600" :class="{ 'pay-in__selected-color': isSelected(PAYMENT_SCOPE.FULL_BOOKING) }">Full booking</strong>
                <span class="fs-small dark mt-1">Pay the full reservation balance or a partial<br>amount of the total</span>
            </div>

            <div
                class="pay-in__scope-card"
                :class="{ 
                    'pay-in__scope-card--selected': isSelected(PAYMENT_SCOPE.PARTIAL_ITEMS),
                    'pay-in__scope-card--disabled': isFirstPaymentFull
                }"
                :style="{ cursor: isFirstPaymentFull ? 'not-allowed' : 'pointer', opacity: isFirstPaymentFull ? 0.5 : 1 }"
                @click="!isFirstPaymentFull && $emit('input', PAYMENT_SCOPE.PARTIAL_ITEMS)"
            >
                <i class="fas fa-list mb-2 fs-large" :class="isSelected(PAYMENT_SCOPE.PARTIAL_ITEMS) ? 'pay-in__selected-color' : 'dark'"></i>
                <strong class="font-weight-600" :class="{ 'pay-in__selected-color': isSelected(PAYMENT_SCOPE.PARTIAL_ITEMS) }">Partial item payments</strong>
                <span class="fs-small dark mt-1">Select specific ticket types and extras<br>to pay for</span>
            </div>
        </div>

        <div class="d-flex justify-content-end align-items-center mt-4">
            <label class="mr-2 fs-medium">Due to Pay</label>
            <span class="fs-large font-weight-600 mr-4">{{ formatPrice(amountDue) }} €</span>
            <label class="mr-2 fs-medium">Total</label>
            <span class="fs-large font-weight-600">{{ formatPrice(grandTotal) }} €</span>
        </div>
    </div>
</template>

<script>
import { reservationsMixin } from '@/mixins/reservations'
import { PAYMENT_SCOPE } from '@/tools/modal/ReservationPayIn/payInHelpers'
import { mapGetters } from 'vuex'
export default {
    mixins: [reservationsMixin],
    props: {
        value: {
            type: String,
            default: null,
        },
        grandTotal: {
            type: Number,
            required: true,
        },
        amountDue: {
            type: Number,
            required: true,
        },
        selectedReservation: {
            type: Object,
            default: null,
        },
    },
    data() {
        return { PAYMENT_SCOPE }
    },
    computed: { 
        ...mapGetters([
            'getReservationCreation',
        ]),
        hasPayments() {
            return this.selectedReservation && this.selectedReservation.payments && this.selectedReservation.payments.length > 0
        },
        isFirstPaymentFull() {
            if (this.getReservationCreation || !this.hasPayments) return false
            if (this.selectedReservation.payments[0].isFullAmount !== true) return false
            return this.amountDue <= 0
        },
        isFirstPaymentPartial() {
            if (this.getReservationCreation || !this.hasPayments) return false
            if (this.selectedReservation.payments[0].isFullAmount !== false) return false
            return this.amountDue <= 0
        },
    },
    methods: {
        isSelected(scope) {
            return this.value === scope
        },
    },
}
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_variables.scss';

    $green-dark: $color-3;
    $selected-bg-opacity: 0.06;
    $transition-speed: 0.15s;

    .pay-in__selected-color {
        color: $green-dark !important;
    }

    .pay-in__body {
        min-height: 11.25rem;
    }

    .pay-in__scope-card {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: 1.5rem 1rem;
        border: 1px solid $light;
        border-radius: 0.375rem;
        cursor: pointer;
        background: $lightest;
        transition: border-color $transition-speed, background $transition-speed;

        &--selected {
            border-color: $green-dark;
            background: rgba($green-dark, $selected-bg-opacity);
        }

        &--disabled {
            cursor: not-allowed;
            opacity: 0.5;
            
            &:hover {
                border-color: $light;
                background: $lightest;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// Step1Scope.vue?1be002df